import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Usa() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Usa') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [name, setName] = useState();
    const [accNum, setAccNum] = useState();
    const [wirelessAccNum, setWirelessAccNum] = useState();
    const [cnam, setCnam] = useState();
    const [contName, setContName] = useState();

    const [state, setState] = useState();

    // List of states in the USA
    const states = [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'PR', name: 'Puerto Rico' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' },
    ];

    const [city, setCity] = useState();
    const [zip, setZip] = useState();
    const [companyName, setCompanyName] = useState();
    const [sName, setSName] = useState();
    const [sNum, setSNum] = useState();

    const [name2, setName2] = useState();
    const [title, setTitle] = useState();
    const [date, setDate] = useState();

    // Function to get today's date in YYYY-MM-DD format
    // const getCurrentDate = () => {
    //     const today = new Date();
    //     const year = today.getFullYear();
    //     const month = (`0${today.getMonth() + 1}`).slice(-2); // Add leading zero to month
    //     const day = (`0${today.getDate()}`).slice(-2); // Add leading zero to day
    //     return `${year}-${month}-${day}`;
    // };

    // // Set the date field to the current date when the component mounts
    // useEffect(() => {
    //     setDate(getCurrentDate());
    // }, []);

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#name').value = form?.country?.donor?.name ?? '';
        document.querySelector('#accNum').value = form?.country?.donor?.accNum ?? '';
        document.querySelector('#wirelessAccNum').value = form?.country?.donor?.wirelessAccNum ?? '';
        document.querySelector('#cnam').value = form?.country?.donor?.cnam ?? '';
        setName(form?.country?.donor?.name ?? '');
        setAccNum(form?.country?.donor?.accNum ?? '');
        setWirelessAccNum(form?.country?.donor?.wirelessAccNum ?? '');
        setCnam(form?.country?.donor?.cnam ?? '');

        document.querySelector('#companyName').value = form?.country?.customer?.companyName ?? '';
        document.querySelector('#contName').value = form?.country?.customer?.cName ?? '';
        document.querySelector('#state').value = form?.country?.customer?.state ?? '';
        document.querySelector('#city').value = form?.country?.customer?.city ?? '';
        document.querySelector('#zip').value = form?.country?.customer?.zip ?? '';
        document.querySelector('#sName').value = form?.country?.customer?.sName ?? '';
        document.querySelector('#sNum').value = form?.country?.customer?.sNum ?? '';
        setCompanyName(form?.country?.customer?.companyName ?? '');
        setContName(form?.country?.customer?.cName ?? '');
        setState(form?.country?.customer?.state ?? '');
        setCity(form?.country?.customer?.city ?? '');
        setZip(form?.country?.customer?.zip ?? '');
        setSName(form?.country?.customer?.sName ?? '');
        setSNum(form?.country?.customer?.sNum ?? '');

        setTableData(form?.country?.portedNumbers?.range ?? []);

        document.querySelector('#name2').value = form?.country?.requestor?.name2 ?? '';
        document.querySelector('#title').value = form?.country?.requestor?.title ?? '';
        document.querySelector('#date').value = form?.country?.requestor?.date ?? '';
        setName2(form?.country?.requestor?.name2 ?? '');
        setTitle(form?.country?.requestor?.title ?? '');
        setDate(form?.country?.requestor?.date ?? '');

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };



    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableData, setTableData] = useState([{ id: Date.now(), rangeStart: '', rangeStop: '', num: '' }]);

    //adding a row
    const addRow = () => {
        setTableData([...tableData, { id: Date.now(), rangeStart: '', rangeStop: '', num: '' }]);
    };

    //removing a row
    const removeRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    // change handler of table
    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableData(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            const dataRows = jsonData.slice(1);
            const validation = {};
            const formattedDataRange = dataRows.map((row, index) => {
                const id = index + 1;

                const rangeStart = row[0] ? row[0].toString() : '';
                const rangeStop = row[1] ? row[1].toString() : '';
                const num = row[4] ? row[4].toString() : '';

                // Validate start
                validation[`start-${id}`] = /^\d{10}$/.test(rangeStart);

                // Validate end
                validation[`end-${id}`] = /^\d{10}$/.test(rangeStop);

                // Validate num (BTN)
                validation[`num-${id}`] = num === '' || /^\d{10}$/.test(num);

                // Check interdependency: end >= start
                if (
                    validation[`start-${id}`] &&
                    validation[`end-${id}`] &&
                    parseInt(rangeStop, 10) < parseInt(rangeStart, 10)
                ) {
                    validation[`start-${id}`] = false;
                    validation[`end-${id}`] = false;
                    //toast.error(`Row ${id}: End range must be greater than or equal to start range.`);
                }

                return {
                    id,
                    rangeStart,
                    rangeStop,
                    num
                };
            });

            setTableData(formattedDataRange);
            setValidationStates(validation);
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableData([{ id: Date.now(), rangeStart: '', rangeStop: '', num: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };


    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Usa",
            "donor": {
                "name": name,
                "accNum": accNum,
                "wirelessAccNum": wirelessAccNum,
                "cnam": cnam
            },
            "customer": {
                "cName": contName,
                "state": state,
                "city": city,
                "zip": zip,
                "companyName": companyName,
                "sName": sName,
                "sNum": sNum

            },
            "portedNumbers": {
                "range": tableData
            },
            "requestor": {
                "name2": name2,
                "title": title,
                "date": date
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    // console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!name) {
            validationErrors.name = 'please fill in Operator/Service Provider Name';
        }
        if (!accNum) {
            validationErrors.accNum = 'please fill in Account Number';
        }
        if (!companyName) {
            validationErrors.companyName = 'please fill in Company Name';
        }
        if (!contName) {
            validationErrors.contName = 'please fill in Contact Name';
        }
        if (!state) {
            validationErrors.state = 'please fill in State';
        }
        if (!city) {
            validationErrors.city = 'please fill in City';
        }
        if (!zip) {
            validationErrors.zip = 'please fill in Zip';
        }
        if (!sName) {
            validationErrors.sName = 'please fill in Street Name';
        }
        if (!sNum) {
            validationErrors.sNum = 'please fill in Street Number';
        }
        tableData.forEach((row, index) => {
            if (!row.rangeStart) {
                validationErrors[`start-${row.id}`] = `please fill in First number in range for row ${index + 1}`;
            }
            if (!row.rangeStop) {
                validationErrors[`end-${row.id}`] = `please fill in Last number in range for row ${index + 1}`;
            }
            if (!row.num) {
                validationErrors[`num-${row.id}`] = `please fill in Billing Telephone Number(BTN) for row ${index + 1}`;
            }
        });
        if (!name2) {
            validationErrors.name2 = "please fill in Name in Requestor's Details";
        }
        if (!title) {
            validationErrors.title = 'please fill in Title';
        }
        if (!date) {
            validationErrors.date = 'please fill in Date';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = accNum + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home'
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <h2 className='heading'>Service Provider / Losing Operator</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Operator/Service Provider Name*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id="name"
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter the current service provider (e.g. Lightpath)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('accNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Account Number*</label> <br />
                            <input
                                onChange={(e) => setAccNum(e.target.value)}
                                type="text"
                                id="accNum"
                                placeholder=""
                                className={`inputbox ${validationStates.accNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('accNum', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'accNum' && (
                                <div className="hover-description">
                                    Enter the account number as seen on current bill (e.g. 44411)
                                </div>
                            )}
                        </Col>

                        {/* <Col
                            onMouseEnter={() => handleMouseEnter('wirelessAccNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Wireline Pin Number</label> <br />
                            <input
                                onChange={(e) => setWirelessAccNum(e.target.value)}
                                type="text"
                                id="wirelessAccNum"
                                placeholder=""
                                className={`inputbox`}
                                // onBlur={() => validateInput('wirelessAccNum', /^[a-zA-Z0-9@]+$/)}

                            />
                            {hoveredField === 'wirelessAccNum' && (
                                <div className="hover-description">
                                    In case of a wireless/ mobile telephone number, add the pin number here.
                                </div>
                            )}
                        </Col> */}
                        <Col
                            onMouseEnter={() => handleMouseEnter('wirelessAccNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Wireline PIN Number</label> <br />
                            <input
                                onChange={(e) => setWirelessAccNum(e.target.value)}
                                type="text"
                                id="wirelessAccNum"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'wirelessAccNum' && (
                                <div className="hover-description">
                                    In case of a wireless/ mobile telephone number, add the pin number here.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col xs={4}
                            onMouseEnter={() => handleMouseEnter('cnam')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>CNAM (Caller Name Delivery)</label> <br />
                            <input
                                onChange={(e) => setCnam(e.target.value)}
                                type="text"
                                id="cnam"
                                placeholder=""
                                className={`inputbox ${validationStates.cnam === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[a-zA-Z0-9&\s]{1,15}$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, cnam: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'CNAM must be alphanumeric, up to 15 characters, and may include "&" only.'
                                        );
                                    }
                                }}
                            />
                            {hoveredField === 'cnam' && (
                                <div className="hover-description">
                                    (15 characters maximum. No special characters are allowed except "&". Is a US based telephone network service that displays the name of the business alongside their phone number on recipient device)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Customer Details</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id="companyName"
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    Enter end user name (e.g. Sun Chemical)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Portability Authorized Person*</label> <br />
                            <input
                                onChange={(e) => {
                                    setContName(e.target.value)
                                    setName2(e.target.value); // Update name2 with the value from contName
                                }}
                                type="text"
                                id="contName"
                                placeholder=""
                                className={`inputbox ${validationStates.contName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contName', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'contName' && (
                                <div className="hover-description">
                                    To be filled with the name of the "Authorized Person", who is allowed to submit a portability request.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('state')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>State*</label> <br />
                            <select
                                id="state"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                className={`inputbox ${validationStates.state === false ? 'error' : ''}`}
                                onBlur={() => validateInput('state', /^[\w\W,]+$/)}
                            >
                                <option value="">Select a state</option>
                                {states.map((state) => (
                                    <option key={state.code} value={state.name}>
                                        {state.name}
                                    </option>
                                ))}
                            </select>
                            {hoveredField === 'state' && (
                                <div className="hover-description">
                                    Select a State
                                </div>
                            )}
                        </Col>

                        <Row></Row>

                        <br></br>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('sName')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Street Name*</label> <br />
                                <input
                                    onChange={(e) => setSName(e.target.value)}
                                    type="text"
                                    id="sName"
                                    placeholder=""
                                    className={`inputbox ${validationStates.sName === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('sName', /^[a-zA-Z\s]+$/)}

                                />
                                {hoveredField === 'sName' && (
                                    <div className="hover-description">
                                        Enter end user street name
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('sNum')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Street Number*</label> <br />
                                <input
                                    onChange={(e) => setSNum(e.target.value)}
                                    type="text"
                                    id="sNum"
                                    placeholder=""
                                    className={`inputbox ${validationStates.sNum === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('sNum', /^[a-zA-Z0-9\s\W]+$/)}

                                />
                                {hoveredField === 'sNum' && (
                                    <div className="hover-description">
                                        Enter end user street number
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('city')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>City*</label> <br />
                                <input
                                    onChange={(e) => setCity(e.target.value)}
                                    type="text"
                                    id="city"
                                    placeholder=""
                                    className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('city', /^[a-zA-Z\s]+$/)}

                                />
                                {hoveredField === 'city' && (
                                    <div className="hover-description">
                                        Enter end user city
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('zip')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Zip*</label> <br />
                                <input
                                    onChange={(e) => setZip(e.target.value)}
                                    type="text"
                                    id="zip"
                                    placeholder=""
                                    className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('zip', /^\d{1,5}$/)}

                                />
                                {hoveredField === 'zip' && (
                                    <div className="hover-description">
                                        Enter end user 5-digit zip code (e.g. 10566)
                                    </div>
                                )}
                            </Col>

                        </Row>

                    </Row>

                    <br />

                </Container>


                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Numbers to be ported</h2> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>

                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>First number in range*</th>
                                <th>Last number in range*</th>
                                <th>Billing Telephone Number(BTN)*</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>

                            {tableData.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`start-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`start-${row.id}`} // Dynamic ID for start input
                                            value={row.rangeStart}
                                            onChange={(e) => handleChange_table(row.id, 'rangeStart', e.target.value)}
                                            className={`inputbox ${validationStates[`start-${row.id}`] === false ? 'error' : ''}`}
                                            // onBlur={(e) => {
                                            //     const startValue = e.target.value;
                                            //     const start = parseInt(startValue, 10);
                                            //     const end = parseInt(row.rangeStop, 10);

                                            //     // Validate the input for exactly 10 digits
                                            //     if (!/^\d{10}$/.test(startValue)) {
                                            //         toast.error('Start range must be a 10-digit number');
                                            //         setValidationStates(prev => ({
                                            //             ...prev,
                                            //             [`start-${row.id}`]: false,
                                            //         }));
                                            //     } else {
                                            //         setValidationStates(prev => ({
                                            //             ...prev,
                                            //             [`start-${row.id}`]: true,
                                            //         }));

                                            //         // Check if end range is valid
                                            //         if (row.rangeStop) {
                                            //             if (end < start) {
                                            //                 toast.error('End range must be greater than or equal to start range');
                                            //                 setValidationStates(prev => ({
                                            //                     ...prev,
                                            //                     [`end-${row.id}`]: false,
                                            //                 }));
                                            //             } else {
                                            //                 setValidationStates(prev => ({
                                            //                     ...prev,
                                            //                     [`end-${row.id}`]: true,
                                            //                 }));
                                            //             }
                                            //         }
                                            //     }
                                            // }}
                                            onBlur={(e) => {
                                                const startValue = e.target.value;
                                                const start = parseInt(startValue, 10);
                                                const end = parseInt(row.rangeStop, 10);

                                                const startValid = /^\d{10}$/.test(startValue);
                                                const endValid = /^\d{10}$/.test(row.rangeStop);

                                                let updates = {
                                                    [`start-${row.id}`]: startValid,
                                                    [`end-${row.id}`]: endValid
                                                };

                                                if (startValid && endValid) {
                                                    if (end < start) {
                                                        toast.error('End range must be greater than or equal to start range');
                                                        updates[`start-${row.id}`] = false;
                                                        updates[`end-${row.id}`] = false;
                                                    }
                                                }

                                                setValidationStates(prev => ({ ...prev, ...updates }));
                                            }}

                                        />
                                        {hoveredField === `start-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the start of range to be ported (must be a 10-digit number, e.g., 9142226900)
                                            </div>
                                        )}
                                    </td>
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`end-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`end-${row.id}`} // Dynamic ID for end input
                                            value={row.rangeStop}
                                            onChange={(e) => handleChange_table(row.id, 'rangeStop', e.target.value)}
                                            className={`inputbox ${validationStates[`end-${row.id}`] === false ? 'error' : ''}`}
                                            // onBlur={(e) => {
                                            //     const endValue = e.target.value;
                                            //     const start = parseInt(row.rangeStart, 10);
                                            //     const end = parseInt(endValue, 10);

                                            //     // Validate the input for exactly 10 digits
                                            //     if (!/^\d{10}$/.test(endValue)) {
                                            //         toast.error('End range must be a 10-digit number');
                                            //         setValidationStates(prev => ({
                                            //             ...prev,
                                            //             [`end-${row.id}`]: false,
                                            //         }));
                                            //     } else {
                                            //         setValidationStates(prev => ({
                                            //             ...prev,
                                            //             [`end-${row.id}`]: true,
                                            //         }));

                                            //         // Check if end range is valid
                                            //         if (row.rangeStart) {
                                            //             if (end < start) {
                                            //                 toast.error('End range must be greater than or equal to start range');
                                            //                 setValidationStates(prev => ({
                                            //                     ...prev,
                                            //                     [`start-${row.id}`]: false,
                                            //                     [`end-${row.id}`]: false,
                                            //                 }));
                                            //             } else {
                                            //                 setValidationStates(prev => ({
                                            //                     ...prev,
                                            //                     [`start-${row.id}`]: true,
                                            //                     [`end-${row.id}`]: true,
                                            //                 }));
                                            //             }
                                            //         }
                                            //     }
                                            // }}
                                            onBlur={(e) => {
                                                const endValue = e.target.value;
                                                const start = parseInt(row.rangeStart, 10);
                                                const end = parseInt(endValue, 10);

                                                const startValid = /^\d{10}$/.test(row.rangeStart);
                                                const endValid = /^\d{10}$/.test(endValue);

                                                let updates = {
                                                    [`start-${row.id}`]: startValid,
                                                    [`end-${row.id}`]: endValid
                                                };

                                                if (startValid && endValid) {
                                                    if (end < start) {
                                                        toast.error('End range must be greater than or equal to start range');
                                                        updates[`start-${row.id}`] = false;
                                                        updates[`end-${row.id}`] = false;
                                                    }
                                                }

                                                setValidationStates(prev => ({ ...prev, ...updates }));
                                            }}
                                        />
                                        {hoveredField === `end-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the end of range to be ported (must be a 10-digit number, e.g., 9142226999)
                                            </div>
                                        )}
                                    </td>



                                    <td
                                        onMouseEnter={() => handleMouseEnter(`num-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`num-${row.id}`} // Corrected ID for num input
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_table(row.id, 'num', value);

                                                // Optional: Immediate validation feedback
                                                if (!/^\d{10}$/.test(value) && value !== '') {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`num-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`num-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`num-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur
                                                if (!/^\d{10}$/.test(row.num)) {
                                                    toast.error('Number must be exactly 10 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`num-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `num-${row.id}` && (
                                            <div className="hover-description">
                                                Billing Telephone Number USA (must be exactly 10 digits, e.g., 9142226250)
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableData.length > 1 && (
                                            <button onClick={() => removeRow(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <button onClick={addRow}>Add Row</button>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Requestor's Details</h2> <br></br>


                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name2')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name*</label> <br />
                            <input
                                type="text"
                                id="name2"
                                value={name2} // Hold the state of name2
                                placeholder=""
                                className={`inputbox ${validationStates.name2 === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name2', /^[\w\W,]+$/)} // Ensure this validates correctly
                            />
                            {hoveredField === 'name2' && (
                                <div className="hover-description">
                                    Enter your name
                                </div>
                            )}
                        </Col>


                        <Col
                            onMouseEnter={() => handleMouseEnter('title')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Title*</label> <br />
                            <input
                                onChange={(e) => setTitle(e.target.value)}
                                type="text"
                                id='title'
                                placeholder=""
                                className={`inputbox ${validationStates.title === false ? 'error' : ''}`}
                                onBlur={() => validateInput('title', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'title' && (
                                <div className="hover-description">
                                    Enter your title
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date}
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => { validateInput('date', /^.*$/); }}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Usa;